// localStorage keys
export const ANONYMOUS_USER_ID_KEY = '_anonymousUserId';
export const DEBUG_MODE_KEY = 'debugMode';
export const QUERY_CONSENT_KEY = 'collectedQueryConsent_';

export const mkUserQueryConsentKey = (userId: string) =>
  `${QUERY_CONSENT_KEY}${userId}`;
